import { render, staticRenderFns } from "./CommentSettings.vue?vue&type=template&id=15954842&scoped=true&"
import script from "./CommentSettings.vue?vue&type=script&lang=ts&"
export * from "./CommentSettings.vue?vue&type=script&lang=ts&"
import style0 from "./CommentSettings.vue?vue&type=style&index=0&id=15954842&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15954842",
  null
  
)

export default component.exports